import Logo from 'components/atoms/Logo';
import Menu from 'components/molecules/Menu';
import SearchBar from 'components/molecules/SearchBar';
import classNames from 'classnames';
import './styles.scss';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';

const Header = () => {
  const { setSearchTerm, isSmallHeader, isVisibleHeader } = useContext(GlobalContext);

  const headerClass = classNames({
    header: true,
    'header--small': isSmallHeader,
    'header--isVisible': isVisibleHeader,
  });

  return (
    <>
      <header className={headerClass}>
        <Link to="/" onClick={() => setSearchTerm('')}>
          <Logo small={isSmallHeader} />
        </Link>
        <Menu />
      </header>
      <p className={`header__message ${isVisibleHeader ? 'header__message--visible' : ''}`}>
        As Normas Técnicas (NTS) e os Desenhos Padrão (DPS) são de titularidade exclusiva da Companhia de Saneamento Básico do Estado de São Paulo -
        Sabesp, podendo ser revisadas ou canceladas sempre que a Empresa considerar necessário.
      </p>
    </>
  );
};

export default Header;
